import { Button } from "react-bootstrap";
import PageTitle from "../../../../jsx/layouts/PageTitle";
import AccountRoleManagementList from "./AccountRoleManagementList";
import { useContext, useEffect, useState } from "react";
import ReactPaginate from 'react-paginate';
import { AccountManagementContext } from "../../../../context/AccountManagementContext";
import { Link } from "react-router-dom";
import useSearchValue from "../../../../hooks/useSearchValue";
import SearchFilter from "../../../../jsx/components/SearchFilter/SearchFilter";

export default function AccountRoleManagement() {
    const { loading, RoleAccountList, fetchRoleAccountManagementList } = useContext(AccountManagementContext);
    const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (event) => {
        // Adjusting for zero-based index by adding 1
        const selectedPage = event.selected + 1;
        setCurrentPage(selectedPage);
    };

    useEffect(() => {
        fetchRoleAccountManagementList(
            "",
            "desc",
            debouncedSearchValue,
            perPage,
            currentPage
        );
    }, [debouncedSearchValue, perPage, currentPage]);

    useEffect(() => {
        setCurrentPage(1);
    }, [debouncedSearchValue]);
    return (
        <>
            <PageTitle activeMenu="Roles" motherMenu="User Management" />
            <div className="col-12">
                <div className="card">
                    <div className="card-header d-flex justify-content-between">
                        <div>
                            <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} setCurrentPage={setCurrentPage} />
                        </div>
                        <div>
                            <Link to="/account/role/add">
                                <Button
                                    variant="primary"
                                    className="mx-2"

                                >
                                    Add Role <i className="fa fa-plus"></i>
                                </Button>
                            </Link>

                        </div>
                    </div>

                    <AccountRoleManagementList debouncedSearchValue={debouncedSearchValue} currentPage={currentPage} perPage={perPage} />

                </div>
            </div>

            <ReactPaginate
                nextLabel="next >"
                onPageChange={handlePageChange}
                pageRangeDisplayed={8}
                marginPagesDisplayed={5}
                pageCount={Math.ceil(RoleAccountList?.data?.total / perPage)}
                previousLabel="< previous"
                pageClassName="page-item mx-1 my-1"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link mx-1 my-1"
                nextClassName="page-item mx-1 my-1"
                nextLinkClassName="page-link"
                breakLabel="..."
                breakClassName="page-item mx-1 my-1"
                breakLinkClassName="page-link"
                containerClassName="pagination d-flex flex-wrap"
                activeClassName="active"
                renderOnZeroPageCount={null}
                forcePage={currentPage - 1}
            />

        </>

    );
}